import { Box } from '@mui/material';

import Accordion from '../../accordion/accordion';
import Typography from '../../typography/typography';

export interface ITaxesAndChargesSummary {
	taxes: number | string;
	deductedTax: number | string;
	total: number | string;
	shippingAmount: number | string;
	handlingAmount: number | string;
	currencySymbol: string;
}
interface ITaxesAndChargesSummaryProps {
	data: ITaxesAndChargesSummary;
	enableShippings?: boolean;
}

const TaxesAndChargesSummary: React.FC<ITaxesAndChargesSummaryProps> = ({
	data,
	enableShippings
}) => {
	return (
		<Accordion
			title={
				<Typography type='s3' weight='medium' color='theme.secondary.1000'>
					Taxes and Charges
				</Typography>
			}
			accordionProps={{
				defaultExpanded: true,
				sx: {
					borderBottomWidth: 1,
					'& .MuiAccordionSummary-root': { borderBottomWidth: 1 }
				}
			}}>
			<Box className='calculationSummary--SummaryContainer'>
				<Box className='calculationSummary--SummaryItem'>
					<Typography type='s5' weight='medium' color='theme.secondary.800'>
						Taxes and Charges Added
					</Typography>
					<Typography type='s3' weight='medium' color='theme.secondary.1000'>
						{data.currencySymbol} {data.taxes}
					</Typography>
				</Box>
				<Box className='calculationSummary--SummaryItem'>
					<Typography type='s5' weight='medium' color='theme.secondary.800'>
						Taxes and Charges deducted
					</Typography>
					<Typography type='s3' weight='medium' color='theme.secondary.1000'>
						{data.currencySymbol} {data.deductedTax}
					</Typography>
				</Box>
				<Box className='calculationSummary--SummaryItem'>
					<Typography type='s5' weight='medium' color='theme.secondary.800'>
						Total Taxes and Charges Added
					</Typography>
					<Typography type='s3' weight='medium' color='theme.secondary.1000'>
						{data.currencySymbol} {data.total}
					</Typography>
				</Box>
				{Boolean(enableShippings) && (
					<>
						<Box className='calculationSummary--SummaryItem'>
							<Typography type='s5' weight='medium' color='theme.secondary.800'>
								Shipping Amount
							</Typography>
							<Typography
								type='s3'
								weight='medium'
								color='theme.secondary.1000'>
								{data.currencySymbol} {data.shippingAmount}
							</Typography>
						</Box>
						<Box className='calculationSummary--SummaryItem'>
							<Typography type='s5' weight='medium' color='theme.secondary.800'>
								Handling Amount
							</Typography>
							<Typography
								type='s3'
								weight='medium'
								color='theme.secondary.1000'>
								{data.currencySymbol} {data.handlingAmount}
							</Typography>
						</Box>
					</>
				)}
			</Box>
		</Accordion>
	);
};

export default TaxesAndChargesSummary;
